import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { GlobalContext } from '../contexts/GlobalContext';
import TrialBlockedPage from './TrialBlockedPage';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const { trialStatus, trialLoading } = useContext(GlobalContext);
  if (loading || trialLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check if user is blocked based on trial status
  if (trialStatus) {
    // User has account_type = 'trial' but no trial record
    if (!trialStatus.has_trial && user?.account_type === 'trial') {
      return <TrialBlockedPage status="no_trial" trialData={null} />;
    }

    // User has a trial record, check its status
    if (trialStatus.has_trial && trialStatus.current_trial) {
      const trial = trialStatus.current_trial;

      // Check if trial is revoked
      if (trialStatus.is_revoked) {
        return <TrialBlockedPage status="revoked" trialData={trial} />;
      }

      // Check if trial is expired
      if (trialStatus.is_expired) {
        return <TrialBlockedPage status="expired" trialData={trial} />;
      }

      // Check if trial is pending (not started yet)
      const today = new Date();
      const trialStart = new Date(trial.trial_start_date);
      if (trialStart > today) {
        return <TrialBlockedPage status="pending" trialData={trial} />;
      }

      // Check if trial is inactive (deactivated)
      if (
        !trial.is_active &&
        !trialStatus.is_revoked &&
        !trialStatus.is_expired &&
        !trialStatus.is_promoted
      ) {
        return <TrialBlockedPage status="inactive" trialData={trial} />;
      }
    }
  }

  // User can access the application
  return children;
};

export default ProtectedRoute;
